"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectFilledStatus = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("@ant-design/icons");
var antd_1 = require("antd");
var SelectFilled_1 = require("../SelectFilled");
var data_1 = require("./data");
var transifex_1 = require("../../transifex");
var SelectFilledStatus = function (_a) {
    var style = _a.style, omitOptions = _a.omitOptions, props = __rest(_a, ["style", "omitOptions"]);
    return (react_1.default.createElement(SelectFilled_1.SelectFilled, __assign({ style: __assign({ minWidth: 146 }, style), showSearch: false, placeholder: transifex_1.TX_STATUS, options: Object.keys(data_1.statusTypeData)
            .filter(function (key) { return !(omitOptions === null || omitOptions === void 0 ? void 0 : omitOptions.includes(key)); })
            .map(function (key) {
            var statusTypeDataObject = data_1.statusTypeData[key];
            return {
                value: key,
                colors: statusTypeDataObject.colors,
                optLabel: (react_1.default.createElement(antd_1.Typography, { style: {
                        color: statusTypeDataObject.colors.primary,
                        fontWeight: 600,
                    } }, statusTypeDataObject.label)),
                label: (react_1.default.createElement(antd_1.Row, { style: { padding: "0.25rem", paddingLeft: 0 } },
                    react_1.default.createElement(antd_1.Col, { xs: 24 },
                        react_1.default.createElement(antd_1.Tag, { color: statusTypeDataObject.colors.secondary },
                            react_1.default.createElement(antd_1.Typography, { style: {
                                    color: statusTypeDataObject.colors.primary,
                                } }, statusTypeDataObject.label))))),
            };
        }), suffixIcon: function (colors) {
            var _a;
            return (react_1.default.createElement(icons_1.CaretDownOutlined, { style: {
                    fontSize: 16,
                    marginRight: 10,
                    color: (_a = colors === null || colors === void 0 ? void 0 : colors.primary) !== null && _a !== void 0 ? _a : "lightgray",
                } }));
        } }, props)));
};
exports.SelectFilledStatus = SelectFilledStatus;
exports.default = exports.SelectFilledStatus;
